import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import "../styles/VariableModal.css"; // Nowy plik CSS dla modalów!
import { Loader2 } from "lucide-react";

export function VariableModal({ isOpen, onClose, variables = [], documentId, tenantId, onSuccess, folderId = null, selectedAutomation }) {
  const [formValues, setFormValues] = useState({});
  const [documentName, setDocumentName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customLocation, setCustomLocation] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFormValues(Object.fromEntries(variables.map((key) => [key, ""])));
      // Set document name to template name if available, removing file extension
      const templateName = selectedAutomation?.automationTemplateDocument?.title || selectedAutomation?.automationTemplateDocument?.fileName;
      if (templateName) {
        // Remove file extension (everything after the last dot)
        const nameWithoutExtension = templateName.replace(/\.[^/.]+$/, "");
        setDocumentName(nameWithoutExtension);
      }
    }
  }, [isOpen, variables, selectedAutomation]);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await fetch(`/api/tenants/${tenantId}/automations/${documentId}/generate-automation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          replacements: formValues,
          documentName: documentName,
          customLocation: customLocation,
        }),
      });
      if (onSuccess) onSuccess("Dokument zaktualizowany!", "success");
      onClose();
    } catch (error) {
      if (onSuccess) onSuccess("Błąd aktualizacji dokumentu.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{ minHeight: 340, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxHeight: '85vh', width: 620 }} onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title" style={{ textAlign: 'center', marginBottom: 18 }}>Uzupełnij zmienne</h2>
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginBottom: 12 }}>
          <div className="modal-grid">
            <div className="modal-row">
              <label className="modal-label">Nazwa dokumentu</label>
              <input
                type="text"
                name="documentName"
                value={documentName}
                onChange={e => setDocumentName(e.target.value)}
                className="modal-input"
                placeholder="Wpisz nazwę dokumentu"
                style={{ marginBottom: 12}}
                autoComplete="off"
              />
            </div>
          </div>

          {variables.length > 0 ? (
            <div className="modal-grid" style={{ marginTop: 10 }}>
              {variables.map((variable) => (
                <div key={variable} className="modal-row">
                  <label className="modal-label">{variable}</label>
                  <input
                    type="text"
                    name={variable}
                    value={formValues[variable] || ""}
                    onChange={handleChange}
                    className="modal-input"
                    autoComplete="off"
                  />
                </div>
              ))}
            </div>
          ) : (
            <p className="modal-no-variables" style={{ textAlign: 'center', marginTop: 24 }}>Brak zmiennych do uzupełnienia.</p>
          )}
        </div>
        <div className="modal-buttons" style={{ marginTop: 12, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginRight: 18, minWidth: 0 }}>
            <input
              type="checkbox"
              id="customLocationCheckbox"
              checked={customLocation}
              onChange={e => setCustomLocation(e.target.checked)}
              className="custom-checkbox"
              style={{ marginRight: 10 }}
            />
            <label htmlFor="customLocationCheckbox" className="custom-checkbox-label">
              <span style={{ fontWeight: 600, color: '#222', fontSize: 15, letterSpacing: 0.1, marginLeft: 2 }}>
                Generuj dokument w tym folderze co automatyzacja
              </span>
            </label>
          </div>
          <Button onClick={onClose} className="modal-btn modal-cancel" disabled={isSubmitting}>
            Anuluj
          </Button>
          <Button 
            onClick={handleSubmit} 
            className="modal-btn modal-save"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Loader2 size={18} className="loading-spinner" />
                Przetwarzanie...
              </span>
            ) : "Generuj"}
          </Button>
        </div>
        <style>{`
          .toast {
            position: fixed;
            right: 32px;
            bottom: 32px;
            min-width: 240px;
            max-width: 320px;
            background: #fff;
            color: #222;
            border-radius: 10px;
            box-shadow: 0 4px 24px rgba(0,0,0,0.13);
            padding: 16px 22px;
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 1rem;
            font-weight: 500;
            z-index: 999999;
            animation: toastIn 0.3s cubic-bezier(.4,2,.6,1);
          }
          .toast.success { border-left: 5px solid #22c55e; }
          .toast.error { border-left: 5px solid #ef4444; }
          @keyframes toastIn {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 24px 0 0 0;
            color: #666;
            font-size: 0.95rem;
          }
          .loading-spinner {
            animation: spin 1s linear infinite;
            color: #2563eb;
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .modal-grid {
            width: 100%;
          }
          .modal-row {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 12px;
          }
          .modal-label {
            margin-bottom: 4px;
            font-weight: 500;
            color: #222;
          }
          .modal-input {
            width: 100%;
            box-sizing: border-box;
            padding: 10px 12px;
            border-radius: 8px;
            border: 1px solid #e5e7eb;
            font-size: 1rem;
            background: #f9fafb;
          }
          .custom-checkbox {
            width: 22px;
            height: 22px;
            border-radius: 6px;
            border: 2px solid #2563eb;
            background: #fff;
            transition: box-shadow 0.18s, border 0.18s;
            box-shadow: 0 2px 8px #2563eb22;
            appearance: none;
            outline: none;
            cursor: pointer;
            position: relative;
            margin: 0;
            display: inline-block;
            vertical-align: middle;
          }
          .custom-checkbox:checked {
            background: linear-gradient(90deg, #2563eb 0%, #60a5fa 100%);
            border-color: #2563eb;
          }
          .custom-checkbox:checked::after {
            content: '';
            display: block;
            position: absolute;
            left: 6px;
            top: 2px;
            width: 6px;
            height: 12px;
            border: solid #fff;
            border-width: 0 3px 3px 0;
            transform: rotate(45deg);
            animation: checkmarkIn 0.18s;
          }
          @keyframes checkmarkIn {
            from { opacity: 0; transform: scale(0.7) rotate(45deg); }
            to { opacity: 1; transform: scale(1) rotate(45deg); }
          }
          .custom-checkbox:focus {
            box-shadow: 0 0 0 3px #2563eb33;
            border-color: #2563eb;
          }
          .custom-checkbox-label {
            display: flex;
            align-items: center;
            cursor: pointer;
            user-select: none;
            margin: 0;
            padding: 0;
            transition: color 0.18s;
          }
          .custom-checkbox-label:hover span {
            color: #2563eb;
          }
        `}</style>
      </div>
    </div>
  );
}
